import React from 'react';
import PropTypes from 'prop-types';
import { formatRelative } from 'date-fns';
import { Avatar, Collapse, Divider, List, ListItem, ListItemAvatar, ListItemIcon, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import moment from 'moment';
import { ExpandLess, ExpandMore, Replay, StarBorder } from '@material-ui/icons';

const formatDate = date => {
  let formattedDate = '';
  if (date) {
    // Convert the date in words relative to the current date
    formattedDate = formatRelative(date, new Date());
    // Uppercase the first letter
    formattedDate =
      formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
  }
  return formattedDate;
};

const Message = ({
  id = null,
  createdAt = null,
  text = '',
  displayName = '',
  replies = [],
  photoURL = '',
}) => {
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };
  if (!text) return null;

  return (
    <>
      <ListItem key={id} className='py-0' disableGutters style={{ width: "80%" }}>
        <ListItemAvatar>
          <Avatar style={{ background: "transparent", border: "2px solid #E38301", color: "#E38301" }}>
            {photoURL ? <img src={photoURL} /> : displayName && displayName[0].toUpperCase()}
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={displayName} secondary={<p className='mb-0' style={{ wordWrap: "break-word" }}>{text}</p>} />
        <ListItemSecondaryAction>
          {createdAt?.seconds ? (
            <span className="text-gray-500 text-xs">
              {moment.unix(createdAt.seconds).fromNow()}
            </span>
          ) : null}
        </ListItemSecondaryAction>
      </ListItem>
      {
        replies.length > 0 &&

        <List component="div" disablePadding className='ml-4 pl-4'>
          {
            replies.map((s) => {
              return <ListItem button>
                <ListItemIcon>
                  <Replay />
                </ListItemIcon>
                <ListItemText primary={<span className="text-gray-500 text-sm" style={{ fontStyle: "italic" }}>{s.text}</span>} />
                <ListItemSecondaryAction>
                  <span className="text-gray-500 text-xs">
                    {moment.unix(s.createdAt).fromNow()}
                  </span>
                </ListItemSecondaryAction>
              </ListItem>
            })
          }

        </List>

      }

      <Divider />
    </>
  );
};

Message.propTypes = {
  text: PropTypes.string,
  createdAt: PropTypes.shape({
    seconds: PropTypes.number,
  }),
  displayName: PropTypes.string,
  photoURL: PropTypes.string,
};

export default Message;
